import {
  Box,
  CircularProgress,
  Container,
  createStyles,
  LinearProgress,
  makeStyles,
  Typography,
  withStyles,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ReactHTMLParser from "react-html-parser";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

import { producaov2 } from "../../../../../../services/apis";

const CustomProgressBar = withStyles(() => 
  createStyles({
    root: {
      display: "flex",
      flexGrow: "1",
      height: "1rem",
    },
    colorPrimary: {
      backgroundColor: '#ffeadb'
    },
    bar: {
      borderRadius: '0.25rem',
      backgroundColor: '#ff7417'
    }
  })
)(LinearProgress)

const useStyles = makeStyles(() => ({
  container: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "100%"
  },
  questionContainer: {
    backgroundColor: "#fff",
    borderRadius: "0.25rem",
    padding: "1rem",
    boxShadow: "0 0 2px 0 #AAA",
  },
  questionOptions: {
    marginTop: "1rem",
  },
  openQuestions: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
  },
  openQuestion: {
    backgroundColor: "#EEE",
    padding: "1rem",
    borderRadius: "0.25rem",
  },
  closedQuestions: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
  progressContainer: {
    display: "flex",
    width: "100%",
    gap: "1rem",
    alignItems: "center",
  },
  option: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    marginBottom: '0.5rem'
  },
  optionIcon: {
    display: "flex",
  },
  loadingContainer: {
    display: "flex",
    height: "20rem",
    width: "100%",
    justifyContent: "center",
    alignItems: "center"
  }
}));

const QuestionOptions = ({ options = null, result = [] }) => {
  const styles = useStyles();

  if (!options) {
    const openAnswers = Object.keys(result?.answers || {});

    return (
      <Box className={styles.openQuestions}>
        {openAnswers.map((answer) => {
          return <Box className={styles.openQuestion}>{answer}</Box>;
        })}
      </Box>
    );
  }

  const totalAnswer = Object.values(result?.answers || {}).reduce(
    (prev, answerCount) => prev + +answerCount,
    0
  );

  return (
    <Box className={styles.closedQuestions}>
      {options?.map((option, index) => {
        const answerCount = result?.answers?.[index] || 0;

        const answerPercent = totalAnswer > 0 ? answerCount / totalAnswer : 0;

        return (
          <Box className={styles.closedQuestions}>
            <Box>
              {console.log(option)}
              <Typography variant="body1" className={styles.option}>
                {option?.text}
                {option?.isAnswer && (
                  <span className={styles.optionIcon}>
                    <IoMdCheckmarkCircleOutline
                      size="1.5em"
                      color="#21ba45"
                    />
                  </span>
                )}
              </Typography>
              <Box className={styles.progressContainer}>
                <CustomProgressBar
                  variant="determinate"
                  value={answerPercent * 100}
                />
                <Typography variant="body2">{answerCount} respostas</Typography>
              </Box>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default function QuestionsResults({ courseID, testJSID, questions }) {
  const styles = useStyles();

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getResults = async () => {
      if (!testJSID || !courseID) {
        return null;
      }

      setLoading(true);

      try {
        const response = await producaov2.get(
          `/admin/testesV2/${testJSID}/result-metrics?courseID=${courseID}`
        );

        setResults(response.data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    getResults();
  }, [testJSID, courseID]);

  return (
    <Box className={styles.container}>
      {loading && (
        <Box className={styles.loadingContainer}>
          <CircularProgress color="primary" />
        </Box>
      )}
      {!loading && (
        questions?.map((question) => {
          const result = results?.find(
            (result) => result?.questionID === question?.id
          );

          return (
            <Box className={styles.questionContainer}>
              <Typography variant="h6">
                {ReactHTMLParser(question?.title)}
              </Typography>
              <Box className={styles.questionOptions}>
                <QuestionOptions options={question?.options} result={result} />
              </Box>
            </Box>
          );
        })
      )}
    </Box>
  );
}
